// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transfer-client-owner[data-v-359219aa]  .el-form-item__label{height:30px}.transfer-client-owner[data-v-359219aa]  .el-form-item{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
